export default __webpack_public_path__ + "static/media/dice_active.a922b7d8.svg";